import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import { TOKEN } from './config/config';
import { AdminRoutes } from './routes/AdminRoutes';
import PathRoute from './PathRoute';

const ResetPassword = React.lazy(() => import('./pages/forgot-pass/ResetPassword'));
const LandingPage = React.lazy(() => import('./pages/landingPage/LandingPage'));
const PrivacyPolicyPage = React.lazy(() => import('./pages/landingPage/PrivacyPolicy'));
const TermsConditionsPage = React.lazy(() => import('./pages/landingPage/TermsConditions'));
const VerifyEmail = React.lazy(() => import('./pages/verify-email/VerifyEmail'));
const PublicLayout = React.lazy(() => import('./layouts/public/PublicLayout'));
const LandingPageLayout = React.lazy(() => import('./layouts/LandingPageLayout'));
const DashboardLayout = React.lazy(() => import('./layouts/dashboard'));
const ForgetPassword = React.lazy(() => import('./pages/forgot-pass/ForgotPassword'));
const Login = React.lazy(() => import('./pages/Login'));
const ChangePassword = React.lazy(() => import('./pages/ChangePassword'));
const Register = React.lazy(() => import('./pages/Register'));

// ----------------------------------------------------------------------
const baseRedirect = () => {
    let path = '';
    if (localStorage.getItem(TOKEN)) {
        path = '/dashboard/analytics';
    } else {
        path = '/auth/login';
    }
    return path;
};
export const children = () => {
    let dashboardChildrens = [
        { path: '', element: <Navigate to={baseRedirect()} />, name: 'Dashboard', title: 'Dashboard', icon: 'mdi:view-dashboard' },

    ];
    
    dashboardChildrens = Array.from(dashboardChildrens).concat(AdminRoutes);
    return dashboardChildrens;
};
export default function Router() {
    // const isAuthenticated = localStorage.getItem(TOKEN)?true:false
    return useRoutes([
        // {
        //     path: '/',
        //     element: <Navigate to={baseRedirect()} />,
        // },
        {
            path: '/',
            element: <LandingPageLayout />,
            children: [
                {
                    path: PathRoute.home,
                    name: 'Home',
                    element: <LandingPage />,
                },
                {
                    path: PathRoute.privacy_policy,
                    name: 'Privacy Policy',
                    element: <PrivacyPolicyPage />,
                },
                {
                    path: PathRoute.terms_conditions,
                    name: 'Privacy Policy',
                    element: <TermsConditionsPage />,
                }
            ],
        },
        {
            path: '/dashboard',
            element: <DashboardLayout />,
            children: [...children()],
        },
        {
            path: 'auth',
            element: <PublicLayout />,
            children: [
                {
                    path: 'login',
                    name: 'Login',
                    element: <Login />,
                },
                {
                    path: 'register',
                    name: 'Register',
                    element: <Register />,
                },
                {
                    path: 'forget-password',
                    name: 'Forgot Password',
                    element: <ForgetPassword />,
                },
                {
                    path: 'reset-password',
                    name: 'Reset Password',
                    element: <ResetPassword />,
                },
                {
                    path: 'verify-email',
                    name: 'Verify Email',
                    element: <VerifyEmail />,
                },
            ],
        },
        {
            path: '*',
            element: <Navigate to="/" />,
        },
    ]);
}
